<template>
  <div
    class="rounded-xs body-1 min-w-[78px] p-4 text-center"
    :class="
      timeData.isExpired
        ? 'bg-static-warning-mid text-static-warning-hi'
        : 'bg-static-info-mid text-static-brand-hi'
    "
  >
    {{ timeData.hours }} : {{ timeData.minutes }}
    <sup class="relative -top-[3px] inline-block min-w-15 text-center">
      {{ timeData.seconds }}
    </sup>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

type Time =
  ApiSpecs['/api/mobile-plan/in-store/v1/magic-links/:magicLinkId']['GET']['response']['expiresAt']

const props = defineProps<{
  expirationTime: Time
}>()

const currentTime = ref(new Date())
const intervalId = ref<ReturnType<typeof setInterval> | null>(null)

const timeData = computed(() => {
  const expiration = new Date(props.expirationTime)
  const now = currentTime.value
  const diff = expiration.getTime() - now.getTime()

  if (diff <= 0) {
    return { hours: '00', minutes: '00', seconds: '00', isExpired: true }
  }

  const totalSeconds = Math.floor(diff / 1000)
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    '0',
  )
  const seconds = String(totalSeconds % 60).padStart(2, '0')

  return { hours, minutes, seconds, isExpired: false }
})

onMounted(() => {
  intervalId.value = setInterval(() => {
    currentTime.value = new Date()
  }, 1000)
})

onUnmounted(() => {
  if (intervalId.value !== null) {
    clearInterval(intervalId.value)
  }
})
</script>
